import WidgetModule from "@eisinc/Overrides/Widgets/Header/SearchHistory";

export * from "@eisinc/Overrides/Widgets/Header/SearchHistory";

export default WidgetModule;
